webpackJsonp([35783957827783],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/gumtree-preview_925.525ad652.jpg";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kincare-preview_925.074cc6d5.jpg";

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/mca-preview_925.80c1dd62.jpg";

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/p2p-preview_925.5a3dd8bb.jpg";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/uts-preview_925.8e7fe211.jpg";

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wsu-preview_925.fcd18549.jpg";

/***/ }),

/***/ 191:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(210);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(337);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectPreview = function (_Component) {
	  _inherits(ProjectPreview, _Component);
	
	  function ProjectPreview() {
	    _classCallCheck(this, ProjectPreview);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  ProjectPreview.prototype.render = function render() {
	    var _props = this.props,
	        heading = _props.heading,
	        children = _props.children,
	        className = _props.className,
	        link = _props.link,
	        image = _props.image,
	        ratio = _props.ratio,
	        client = _props.client,
	        col = _props.col;
	
	
	    var colClass = void 0;
	
	    if (col) {
	      colClass = 'col-md-' + col;
	    } else {
	      colClass = 'col-md-8';
	    }
	    var previewClass = (0, _classnames2.default)('project-preview col-xs-17 ' + colClass, className);
	
	    var imgUrl = image;
	    var imageStyle = {
	      backgroundImage: 'url(' + imgUrl + ')',
	      paddingBottom: ratio + '%'
	    };
	
	    var imageDiv = void 0;
	
	    if (imgUrl) {
	      imageDiv = _react2.default.createElement('div', {
	        className: 'image-container',
	        style: imageStyle });
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { className: previewClass },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: link },
	        imageDiv,
	        _react2.default.createElement(
	          'div',
	          { className: 'card-wrapper card-title' },
	          _react2.default.createElement(
	            'h3',
	            null,
	            heading
	          ),
	          _react2.default.createElement(
	            'h3',
	            null,
	            client
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'card-content' },
	          children
	        )
	      )
	    );
	  };
	
	  return ProjectPreview;
	}(_react.Component);
	
	ProjectPreview.propTypes = {
	  heading: _react.PropTypes.string,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  link: _react.PropTypes.string,
	  image: _react.PropTypes.string,
	  ratio: _react.PropTypes.string,
	  col: _react.PropTypes.string,
	  client: _react.PropTypes.string
	};
	
	exports.default = ProjectPreview;
	module.exports = exports['default'];

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _ProjectPreview = __webpack_require__(191);
	
	var _ProjectPreview2 = _interopRequireDefault(_ProjectPreview);
	
	var _AHref = __webpack_require__(17);
	
	var _AHref2 = _interopRequireDefault(_AHref);
	
	var _mcaPreview_ = __webpack_require__(450);
	
	var _mcaPreview_2 = _interopRequireDefault(_mcaPreview_);
	
	var _p2pPreview_ = __webpack_require__(451);
	
	var _p2pPreview_2 = _interopRequireDefault(_p2pPreview_);
	
	var _utsPreview_ = __webpack_require__(452);
	
	var _utsPreview_2 = _interopRequireDefault(_utsPreview_);
	
	var _kincarePreview_ = __webpack_require__(449);
	
	var _kincarePreview_2 = _interopRequireDefault(_kincarePreview_);
	
	var _wsuPreview_ = __webpack_require__(453);
	
	var _wsuPreview_2 = _interopRequireDefault(_wsuPreview_);
	
	var _gumtreePreview_ = __webpack_require__(448);
	
	var _gumtreePreview_2 = _interopRequireDefault(_gumtreePreview_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IndexPage = function IndexPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'introduction inner' },
	      _react2.default.createElement(
	        'h1',
	        null,
	        'Hello there! I\'m Natalie Johnson. I\'m a designer and developer working in Sydney, Australia.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'inner projects' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row between-xs' },
	        _react2.default.createElement(_ProjectPreview2.default, {
	          image: _p2pPreview_2.default,
	          heading: 'Designing safer and easier ways to buy and sell',
	          client: 'Gumtree Australia',
	          link: 'projects/gumtree-paypal'
	        }),
	        _react2.default.createElement(_ProjectPreview2.default, {
	          image: _mcaPreview_2.default,
	          heading: 'Designing a destination for continuous discovery',
	          client: 'Museum of Contemporary Art Australia',
	          link: '/projects/mca/'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row between-xs' },
	        _react2.default.createElement(_ProjectPreview2.default, {
	          heading: 'An interactive library tour experience',
	          client: 'Western Sydney University Library',
	          link: 'projects/wsu-library',
	          image: _wsuPreview_2.default
	        }),
	        _react2.default.createElement(_ProjectPreview2.default, {
	          image: _utsPreview_2.default,
	          heading: 'Updating a design subject',
	          link: 'projects/uts-web-media',
	          client: 'The University of Technology Sydney'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row between-xs' },
	        _react2.default.createElement(_ProjectPreview2.default, {
	          image: _gumtreePreview_2.default,
	          heading: 'Evolving and optimising Australia\u2019s marketplace',
	          link: 'projects/gumtree',
	          client: 'Gumtree Australia'
	        }),
	        _react2.default.createElement(_ProjectPreview2.default, {
	          className: 'right',
	          heading: 'A new platform to support the leaders of in-home care',
	          image: _kincarePreview_2.default,
	          link: 'projects/kincare',
	          client: 'KinCare'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'contact-panel' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Interested in working together? I\u2019m always open to hearing about exciting projects. Please feel free to say hello!'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-16 col-sm-8 col-md-6' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'h3' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Get in touch'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'h3' },
	                _react2.default.createElement(
	                  _AHref2.default,
	                  { url: 'mailto:natalie@nataliejohnson.com' },
	                  'natalie@nataliejohnson.com'
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'h3' },
	                _react2.default.createElement(
	                  _AHref2.default,
	                  { url: 'tel:+61437685619' },
	                  '+61 437 685 619'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'col-xs-16 col-sm-6' },
	            _react2.default.createElement(
	              'ul',
	              { className: 'h3' },
	              _react2.default.createElement(
	                'h3',
	                null,
	                'Connect'
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: 'h3' },
	                _react2.default.createElement(
	                  _AHref2.default,
	                  { url: 'https://www.linkedin.com/in/natalie-johnson-33a55638/' },
	                  'LinkedIn'
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = IndexPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-08a83ee593bbd2c764b2.js